<template>
    <div id="learnList" :class="$root.isMob() ? 'learnList mob' : ''" v-loading="loading">
        <div class="item" v-for="item in data" :key="item.id" @click="view(item)">
            <div class="img">
                <img :src="API + item.cover_img_text"/>
            </div>
            <div class="title">
              <h3>{{ item.name }}</h3>
            </div>
            <div class="row">
              <div class="describeT1">
                  {{ item.remark }}
              </div>
              <!-- <div class="num">
                <i class="el-icon-user icon"></i>
                {{ item.total_examine_nums }}
              </div> -->
            </div>
            <div class="describe">
                {{ item.remark }}
            </div>
        </div>
        <div class="empty" v-if="data.length == 0">
          <el-empty description="暂无数据"></el-empty>
        </div>
        <div class="learnDetail" v-if="isShowViedeoBox">
          <learnDetail :id="learnID" :isGuest="true" @close="closeLearnDetail"/>
        </div>        
    </div>
</template>
<script>
import learnDetail from './learnDetail.vue';

export default {
  name: 'learnList',
  components: {
    learnDetail
  },
  props: {
    type : {
      type: String,
      default: "1"
    }
  },
  watch: {
    "type"(){
      this.getLearnList(this.type,1);
    }
  },
  data() {
    return {
        data:[],
        API: window.config.api,
        loading:false,
        learnID:0,
        isShowViedeoBox:false,
    }
  },
  methods: {
    closeLearnDetail(){
      this.isShowViedeoBox = false;
      this.learnID = 0;
    },
    async getLearnList(type='',page=1){
        this.loading = true;
        let data = await this.$root.getLearnList('',type,page);   
        if(data){
          this.data = data.data.data;
          this.data.forEach(item => {
            let isOut = false;
            //截取前150字符的简介
            if(item.remark.length > 150){
              isOut = true;
            }
            item.remark = item.remark.substring(0,150);
            if(isOut){
              item.remark = item.remark + "...";
            }
          });
        }   
        this.loading = false;
    },
    async view(item){
      this.loading = true;
      let isLogin = await this.$root.checkLogin();      
      if(isLogin){        
        window.location.href = '/#/userCenter?learnId='+item.id;
      }
      else{
        this.learnID = item.id;
        this.isShowViedeoBox = true;
      }
      this.loading = false;
    },
  },
  created() {
    this.getLearnList(this.type,this.page);
  },
  mounted() {
  }
}
</script>

<style lang="scss" scoped src="@/assets/css/lib/learnList.scss"></style>